<template>
  <div class="relative right-0 h-full flex">
    <iframe 
      src="https://itch.io/embed-upload/16229114?color=333333" 
      allowfullscreen="" 
      width="640" 
      height="380" 
      frameborder="0"
      class="w-full h-full"
    >
      Play Discrete Math Escape Room on itch.io
    </iframe>
  </div>
</template>

<script setup>
// Discrete Math Escape Room embedded from itch.io
</script>
